import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

export const HomeFaqItemClose: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.6, 3.6, props)}>
        <path d="M16.73 24.83 4.207 12.38l2.538-2.554L18 21.015 29.256 9.826l2.538 2.553-12.525 12.45-1.27 1.262z" />
    </svg>
);
